var map = {
	"./no-data-academy.svg": "4449",
	"./no-data-chart.svg": "0d33",
	"./no-data-default.svg": "e87e",
	"./no-data-eval.svg": "1cb1",
	"./no-data-exercise.svg": "85cb",
	"./no-data-file.svg": "42c3",
	"./no-data-injury.svg": "7f07",
	"./no-data-internet.svg": "0acc",
	"./no-data-match.svg": "b678",
	"./no-data-personnel.svg": "623d",
	"./no-data-video.svg": "f289"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e768";